module.exports = __webpack_public_path__ + "static/media/DanielleMattonResume.389f94c1.pdf";